import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import styles from './styles.module.css'
import { ITechnician } from '../../../../../../app/entities/Technician'
import { WeeklyDvirTable } from './components/WeeklyDvirDashboardTable'
import { DailyDvirTable } from './components/DailyDvirDashboardTable'
import { STATUS } from '../../../../global/types/audit'
import getISOWeekNumberFromDate from '../../../utils/get-iso-week-number-of-date'

interface IInstallationAuditModalProps {
  isOpen: boolean
  setIsOpen: Function
  technician: ITechnician | null
  queryDate: Date
}

export default function DvirAuditModal(props: IInstallationAuditModalProps) {
  const { isOpen, setIsOpen, technician, queryDate } = props
  if (!technician) return <> </>
  const isoWeekNumber = getISOWeekNumberFromDate(queryDate)
  const weeklyDvirAudits = technician.audit?.filter(
    (audit) => audit.status === STATUS.WEEKLY_DVIR,
  )
  const dailyDvirAudits = technician.audit?.filter(
    (audit) => audit.status === STATUS.DAILY_DVIR,
  )

  async function handleClosed(): Promise<void> {
    setIsOpen(false)
  }

  return (
    <Modal
      open={isOpen}
      onClose={() => handleClosed()}
    >
      <Box className={styles.auditModal}>
        <div className={styles.modalTitle}>
          <span style={{ fontWeight: 700 }}>{technician.name}:</span> Week{' '}
          {isoWeekNumber}
        </div>
        <div className={styles.tableContaier}>
          <div>
            {dailyDvirAudits && dailyDvirAudits.length > 0 && (
              <DailyDvirTable audits={dailyDvirAudits} />
            )}
          </div>
          <div style={{ marginTop: '20px' }}>
            {weeklyDvirAudits && weeklyDvirAudits.length > 0 && (
              <WeeklyDvirTable audits={weeklyDvirAudits} />
            )}
          </div>
        </div>
      </Box>
    </Modal>
  )
}
